export default __webpack_public_path__ + "static/media/829.aaa5facb.jpg";